import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ShoppingBag, ArrowLeft, Search } from 'lucide-react';
import { Button } from '../components/ui/button';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-[var(--bg-soft)] flex items-center justify-center px-4">
      <div className="max-w-lg w-full text-center">
        {/* Large 404 Display */}
        <div className="mb-8">
          <h1 
            className="text-[120px] sm:text-[160px] font-extrabold leading-none"
            style={{ 
              background: 'linear-gradient(135deg, var(--brand) 0%, var(--brand-dark) 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}
            data-testid="404-heading"
          >
            404
          </h1>
        </div>

        {/* Message */}
        <div className="mb-10">
          <h2 className="text-2xl sm:text-3xl font-bold text-[var(--text)] mb-4">
            Page Not Found
          </h2>
          <p className="text-[var(--muted)] text-base sm:text-lg leading-relaxed max-w-md mx-auto">
            Oops! It looks like this page has wandered off. 
            Let&apos;s help you find your way back to building better habits.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <Link to="/">
            <Button 
              className="w-full sm:w-auto btn btn-primary gap-2 px-6 py-3"
              data-testid="go-home-btn"
            >
              <Home className="h-4 w-4" />
              Go Home
            </Button>
          </Link>
          <Link to="/shop">
            <Button 
              variant="outline"
              className="w-full sm:w-auto btn btn-secondary gap-2 px-6 py-3"
              data-testid="browse-shop-btn"
            >
              <ShoppingBag className="h-4 w-4" />
              Browse Shop
            </Button>
          </Link>
        </div>

        {/* Helpful Links */}
        <div className="pt-8 border-t border-[var(--border)]">
          <p className="text-sm text-[var(--muted)] mb-4">Looking for something specific?</p>
          <div className="flex flex-wrap gap-3 justify-center">
            <Link 
              to="/category/behavior-emotions" 
              className="text-sm text-[var(--brand)] hover:text-[var(--brand-dark)] transition-colors"
            >
              Behavior &amp; Emotions
            </Link>
            <span className="text-[var(--border)]">•</span>
            <Link 
              to="/category/sleep-bedtime" 
              className="text-sm text-[var(--brand)] hover:text-[var(--brand-dark)] transition-colors"
            >
              Sleep &amp; Bedtime
            </Link>
            <span className="text-[var(--border)]">•</span>
            <Link 
              to="/category/screen-time-technology" 
              className="text-sm text-[var(--brand)] hover:text-[var(--brand-dark)] transition-colors"
            >
              Screen Time
            </Link>
            <span className="text-[var(--border)]">•</span>
            <Link 
              to="/category/family-bonding" 
              className="text-sm text-[var(--brand)] hover:text-[var(--brand-dark)] transition-colors"
            >
              Family Bonding
            </Link>
            <span className="text-[var(--border)]">•</span>
            <Link 
              to="/category/child-development" 
              className="text-sm text-[var(--brand)] hover:text-[var(--brand-dark)] transition-colors"
            >
              Child Development
            </Link>
          </div>
        </div>

        {/* Back Link */}
        <div className="mt-8">
          <button 
            onClick={() => window.history.back()} 
            className="inline-flex items-center gap-2 text-sm text-[var(--muted)] hover:text-[var(--text)] transition-colors"
            data-testid="go-back-btn"
          >
            <ArrowLeft className="h-4 w-4" />
            Go back to previous page
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
